import { useCallback, useEffect, useState } from "react";
import { vendorPortalApi, setVendorToken, VENDOR_TOKEN_KEY } from "../api/vendorPortalApi";
import { sanitizeIndianMobile10Input } from "../../util/indianMobile10";

var subscribers = [];
var currentStaff = null;

function notify() {
  for (var i = 0; i < subscribers.length; i++) {
    try { subscribers[i](currentStaff); } catch (_) {}
  }
}

export function useVendorPortalSession() {
  var _s = useState(function () {
    return typeof window !== "undefined" && window.localStorage.getItem(VENDOR_TOKEN_KEY)
      ? "loading"
      : "unauthenticated";
  });
  var status = _s[0], setStatus = _s[1];
  var _st = useState(null);
  var staff = _st[0], setStaff = _st[1];

  useEffect(function () {
    function onChange(s) {
      setStaff(s);
      setStatus(s ? "authenticated" : "unauthenticated");
    }
    subscribers.push(onChange);
    currentStaff = staff;
    if (status === "loading") {
      vendorPortalApi.session()
        .then(function (p) {
          currentStaff = p.staff;
          setStaff(p.staff);
          setStatus("authenticated");
          notify();
        })
        .catch(function () {
          setVendorToken(null);
          setStatus("unauthenticated");
        });
    }
    return function () {
      subscribers = subscribers.filter(function (fn) { return fn !== onChange; });
    };
  }, []); // eslint-disable-line

  var login = useCallback(function (mobile, password) {
    var m = sanitizeIndianMobile10Input(mobile);
    return vendorPortalApi.login(m, password).then(function (p) {
      setVendorToken(p.token);
      currentStaff = p.staff;
      setStaff(p.staff);
      setStatus("authenticated");
      notify();
    });
  }, []);

  var logout = useCallback(function () {
    return vendorPortalApi.logout().finally(function () {
      setVendorToken(null);
      currentStaff = null;
      setStaff(null);
      setStatus("unauthenticated");
      notify();
    });
  }, []);

  var op = staff && staff.operator;
  return {
    status: status,
    staff: staff,
    operator: op,
    eventId: op && op.event_id,
    stallId: op && op.stall_id,
    vendorId: op && op.vendor_id,
    login: login,
    logout: logout
  };
}
